import React from 'react';
import {
  Box,
  CssBaseline,
  Grid,
  Paper,
  Typography,
  Avatar,
  Stack,
} from '@mui/material';
import { PieChart } from '@mui/x-charts';
import { teal, orange, indigo } from '@mui/material/colors';

// Dummy data
const users = [
  { id: 1, name: 'John Doe', email: 'john@example.com', role: 'Admin', status: 'Active' },
  { id: 2, name: 'Jane Smith', email: 'jane@example.com', role: 'User', status: 'Active' },
  { id: 3, name: 'Mike Johnson', email: 'mike@example.com', role: 'User', status: 'Inactive' },
];

const preAuthUpdates = [
  { id: 1, name: 'Policy Update A', status: 'Pending', date: '2024-03-15', priority: 'High' },
  { id: 2, name: 'Security Protocol B', status: 'Approved', date: '2024-03-14', priority: 'Medium' },
  { id: 3, name: 'Access Control C', status: 'Review', date: '2024-03-13', priority: 'Low' },
];

const chartData = [
  { id: 0, value: 3, label: 'Active Users' },
  { id: 1, value: 2, label: 'Pending Updates' },
  { id: 2, value: 1, label: 'Approved Updates' },
];

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f9fafc' }}>
      <CssBaseline />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container spacing={4}>
          {/* Overview Section */}
          <Grid item xs={12} md={8}>
            <Paper
              sx={{
                p: 4,
                height: '100%',
                borderRadius: 3,
                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: teal[700], fontWeight: 'bold' }}
              >
                Overview
              </Typography>
              <PieChart
                series={[
                  {
                    data: chartData,
                    highlightScope: { faded: 'global', highlighted: 'item' },
                    faded: { innerRadius: 30, additionalRadius: -30 },
                  },
                ]}
                height={300}
                colors={[teal[400], orange[400], indigo[400]]}
              />
            </Paper>
          </Grid>

          {/* Quick Stats Section */}
          <Grid item xs={12} md={4}>
            <Paper
              sx={{
                p: 4,
                height: '100%',
                borderRadius: 3,
                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: teal[700], fontWeight: 'bold' }}
              >
                Quick Stats
              </Typography>
              <Stack spacing={3}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: '#f0fdf4',
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Total Users
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{ color: teal[700], fontWeight: 'bold' }}
                    >
                      {users.length}
                    </Typography>
                  </Box>
                  <Avatar sx={{ bgcolor: teal[400] }}>U</Avatar>
                </Paper>

                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: '#fff7ed',
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Active Updates
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{ color: orange[700], fontWeight: 'bold' }}
                    >
                      {preAuthUpdates.length}
                    </Typography>
                  </Box>
                  <Avatar sx={{ bgcolor: orange[400] }}>A</Avatar>
                </Paper>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default App;
